import FeatureGates from '@atlaskit/feature-gate-js-client';
import {
	type ActiveScopeEntry,
	type PostOfficeContextValue,
	type RouteMatch,
	type RouteState,
	createMatchScopes,
} from '@atlassian/post-office-context';
import { createPlacementComponent } from '@post-office/placement-common/utils/create-placement-component';
import type { ErrorBoundariedProps } from '@post-office/placement-contexts/create-placement-component/types';
import { type ComponentType, memo } from 'react';

import { ScreenSpaceFlagsPlacementDefault } from './placement-default';
import { scopes } from './scopes';
import { PLACEMENT_ID } from '../__generated__/common';
import { withScreenSpaceFlagsIntlProvider } from '../__generated__/intl-provider';
import type { Placement as ScreenSpaceFlagsPlacement } from '../contracts/Placement';
import { ScreenSpaceFlagsPlacementTriggeredMessages } from './placement-triggered-messages';

export const matchedScopes = (input: {
	route: RouteState | RouteMatch;
	context: PostOfficeContextValue;
}): ActiveScopeEntry[] => createMatchScopes({ scopes })(input);

export const ScreenSpaceFlagsPlacementComponent: ComponentType<
	ErrorBoundariedProps<ScreenSpaceFlagsPlacement>
> = withScreenSpaceFlagsIntlProvider(
	createPlacementComponent<ScreenSpaceFlagsPlacement>(
		PLACEMENT_ID,
		memo((props) => {
			const choreographTriggeredMessagesEnabled = FeatureGates.checkGate(
				'post-office_enable-triggered-render',
			);

			if (choreographTriggeredMessagesEnabled) {
				// This feature gate enables messages with triggerType gasv3 or poTrigger to be rendered
				// and available to show when the trigger is active.
				return <ScreenSpaceFlagsPlacementTriggeredMessages {...props} />;
			} else {
				return <ScreenSpaceFlagsPlacementDefault {...props} />;
			}
		}),
		{
			choreographer: {
				isDefaultEnabled: true, // this is the default value, but leaving it as explicitly defined
			},
		},
	),
);

export default ScreenSpaceFlagsPlacementComponent;
